import { render, staticRenderFns } from "./ImgBlock.vue?vue&type=template&id=28f3277c&lang=pug&"
import script from "./ImgBlock.vue?vue&type=script&lang=js&"
export * from "./ImgBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports